const preferedMotionMatch = window?.matchMedia?.(
	"(prefers-reduced-motion: no-preference)",
);
// eslint-disable-next-line import/prefer-default-export
export function getPreferedMotion() {
	return preferedMotionMatch?.matches ? "smooth" : "auto";
}
